import { useEffect, useState } from "react";
import { MemberPlans } from "../../../../types/memberPlans";
import { getMemberPlans } from "../../../../client/watch/live";
import { ErrorState, LoadingState } from "../../../States/states";
import { Platform } from "react-native";
import { Plan } from "./Plan";
import GridLayout from "../../../Layout/GridLayout/GridLayout";
import { useAtom } from "jotai";
import { cmsDataAtom } from "../../../../atoms";
import { APIResponse } from "../../../../types/responses/APIResponse";

type Props = {
  limit?: number;
};

export const PlansSection = ({ limit }: Props) => {
  // hide plans on ios
  if (Platform.OS === "ios") return;

  const [response, setResponse] = useState<MemberPlans>();

  const [error, setError] = useState(null);
  const [contentLoading, setContentLoading] = useState(true);
  const [cmsData] = useAtom(cmsDataAtom);

  const fetchPlans = async () => {
    getMemberPlans()
      .then((res: APIResponse<MemberPlans>) => {
        setResponse(res);
      })
      .catch((err) => setError(err))
      .finally(() => setContentLoading(false));
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  // show loading state if data fetch is not complete
  if (contentLoading) return <LoadingState name="MemberPlansLoader" />;

  // show error state if data fetch is complete and there is an error
  if (error)
    return <ErrorState message="Sorry, could not retrieve member plans." />;

  // hide plans if there are no plans returned from the api
  // grid layout doesn't play so nice on native :(
  if (!response?.available_plans) return;

  const currencyMap = {
    GBP: "£",
    EUR: "€",
  };

  if (Platform.OS === "web")
    return (
      <GridLayout styleOverrides={{ paddingTop: 0 }}>
        {response.available_plans
          .slice(0, limit || response.available_plans.length)
          .filter((p) => {
            if (
              p.name === "Free Day Pass" &&
              !cmsData?.settings?.free_day_pass_enabled
            ) {
              return false;
            } else return true;
          })
          .map((plan, index) => (
            <Plan
              key={index}
              currency={currencyMap[response?.currency_code]}
              {...plan}
            />
          ))}
      </GridLayout>
    );

  // show content if data fetch is complete and data is available
  return response.available_plans
    .slice(0, limit || response.available_plans.length)
    .map((plan, index) => (
      <Plan
        key={index}
        currency={currencyMap[response?.currency_code]}
        {...plan}
      />
    ));
};
